import { render, staticRenderFns } from "./kredikartcomp.vue?vue&type=template&id=4cc391e9"
import script from "./kredikartcomp.vue?vue&type=script&lang=js"
export * from "./kredikartcomp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports